import BookingsContact from '@/shared/types/bookings/contact.type';
import Response from '@/shared/types/response';
import chunkArray from '@/shared/utils/chunkArray';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type RequestBody = Pick<BookingsContact, 'booking_service_contact_id'>;

type RemoveContactsProps = {
  bookingServiceId: string;
  body: RequestBody[];
  onUnauthorized?: () => void;
  onProgress?: (progress: number) => void;
};

const removeContacts = async ({
  bookingServiceId,
  body,
  onUnauthorized,
  onProgress,
}: RemoveContactsProps) => {
  const token = getCookie('auth_token');
  const chunks = chunkArray(body, 5);

  const responses: Response<RequestBody>[] = [];

  let finishedRequests = 0;
  const totalRequests = body.length;

  for (const chunk of chunks) {
    const promises = chunk.map((item) => {
      return fetcher<Response<RequestBody>>({
        url: `/bookings/services/${bookingServiceId}/remove_contact/`,
        method: 'DELETE',
        body: { booking_service_contact_id: item.booking_service_contact_id },
        token,
        onUnauthorized,
      })
        .then((response) => {
          finishedRequests++;

          if (onProgress) {
            onProgress((finishedRequests / totalRequests) * 100);
          }

          return response;
        })
        .catch((error) => {
          console.error(
            'Error occurred in function "removeContacts" in file "src/shared/api/bookings/services/removeContacts.ts":',
            error,
          );
          return { ...error, data: item } as Response<RequestBody>[];
        });
    });

    const results = (await Promise.all(promises)) as Response<RequestBody>[];
    responses.push(...results);
  }

  return responses;
};

export default removeContacts;
